import React, { useState } from 'react'
import { Table, Image, Box, Text, NumberFormatter, HoverCard, Group, Anchor, Flex, Menu, ActionIcon, Paper, Badge, Modal, ScrollArea, Button } from '@mantine/core'
import { IconDotsVertical, IconTrash, IconPencil, IconPhoto, IconChecklist, IconCheckbox, IconPackage, IconAB2, IconShare } from '@tabler/icons-react'
import NoImage from '../../../assets/img/images/no-images.png'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={200} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit Request
        </Menu.Item>
        <Menu.Item
          leftSection={<IconPhoto stroke={1.5} size={14} />}
          onClick={() => handleAction('uploadImage')}
          fw='600'
          fz={11}
        >
          Upload Image
        </Menu.Item>
        <Menu.Item
          leftSection={<IconChecklist stroke={1.5} size={14} />}
          onClick={() => handleAction('attachDocument')}
          fw='600'
          fz={11}
        >
          Attach Document
        </Menu.Item>
        <Menu.Item
          leftSection={<IconCheckbox stroke={1.5} size={14} />}
          onClick={() => handleAction(detail.submit_quote_status ? 'confirmedQuote' : 'submitQuote')}
          fw='600'
          fz={11}
        >
          {detail.submit_quote_status ? 'Quote Submitted' : 'Submit Quote'}
        </Menu.Item>
        <Menu.Item
          leftSection={<IconPackage stroke={1.5} size={14} />}
          onClick={() => handleAction('submitRecommendation')}
          fw='600'
          fz={11}
        >
          Submit Recommendation
        </Menu.Item>
        <Menu.Item
          leftSection={<IconAB2 stroke={1.5} size={14} />}
          onClick={() => handleAction('changeStatus')}
          fw='600'
          fz={11}
        >
          Change Status
        </Menu.Item>
        <Menu.Item
          leftSection={<IconShare stroke={1.5} size={14} />}
          onClick={() => handleAction('shareLink')}
          fw='600'
          fz={11}
        >
          Share Link
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableProductRequest = ({ label, data, actionMethod }) => {
  const navigate = useNavigate()
  const [previewImage, setPreviewImage] = useState(null)
  const [openModalImage, setOpenModalImage] = useState(false)

  const onCloseModalImage = () => {
    setOpenModalImage(false)
    setPreviewImage(null)
  }


  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const remapDataProducts = (dataProduct) => {

    const remapDataProduct = dataProduct.map((val, index) => {
      return (
        <Box>
          <Group justify='center'>
            <HoverCard width={400} shadow="md" withArrow>
              <HoverCard.Target>
                <Anchor fz={13} underline="hover" c='blue'>{val.id}{index !== Object.keys(dataProduct).length - 1 ? ',' : ''}</Anchor>
              </HoverCard.Target>
              <HoverCard.Dropdown>
                <Flex align='start' gap='sm'>
                  <Paper shadow="sm" withBorder radius='md'>
                    <Image w={80} h={80} radius='md' src={val.image !== null ? val.image : NoImage} />
                  </Paper>
                  <Box>
                    <Box h={40}>
                      <Text fz={14} lineClamp={2} fw='500'>{val.title}</Text>
                    </Box>
                    <Group justify='space-between' align='center' mt={12}>
                      <Box>
                        <Text fz={11} c='gray.9'>Retail Price</Text>
                        <Text fz={12} fw={600} c='red'><NumberFormatter prefix={`${val.original_currency} `} thousandSeparator="," decimalSeparator="." fixedDecimalScale={true} value={val.regular_price} /></Text>
                      </Box>
                      <Box>
                      <Text fz={11} c='gray.9'>Stock</Text>
                      <Text fz={12} fw={600}>{val.quantity} {val.quantity_unit}</Text>
                      </Box>
                    </Group>
                  </Box>
                </Flex>
              </HoverCard.Dropdown>
            </HoverCard>
          </Group>
        </Box>
      )
    })
    
    return remapDataProduct
  }

  const remapDataQuote = (dataQuote) => {
    const remapData = dataQuote.map((val, index) => {
      return (
        <Box key={index}>
          <Anchor fz={13} underline="hover" c='blue'>{val.attributes.id}{index !== Object.keys(dataQuote).length - 1 ? ',' : ''}</Anchor>
        </Box>
      )
    })

    return remapData
  }

  const mappingDataTable = (data) => data.map((val, index) => {

    const toDetailUser = (dataUser) => {
      if (dataUser !== null) {
        navigate(`/users/${dataUser.id}`)
      }
    }

    const handlePreviewImage = (dataImage) => {
      setOpenModalImage(true)
      setPreviewImage(dataImage)
    }

    return (
      <Table.Tr key={index}>
        <Table.Td>{val.id}</Table.Td>
        <Table.Td>{val.request_number}</Table.Td>
        <Table.Td>
          <Paper shadow="sm" w={62} withBorder radius='md' onClick={() => val.images !== null ? handlePreviewImage(val.images) : ''} style={{ cursor: 'pointer' }}>
            <Image w={60} h={60} radius='md' src={val.images !== null ? val.images : NoImage} />
          </Paper>
        </Table.Td>
        <Table.Td>
          <Box h={40}>
            <Text fz={13} lineClamp={2}>{val.title}</Text>
          </Box>
          <Box mt={10}>
            <Text fz={11} c='gray.6' mb={2}>Brand: {val.brand ? val.brand : '-'}</Text>
            <Text fz={11} c='gray.6'>Quantity: {val.quantity} {val.quantity_unit}</Text>
            <Text fz={11} c='gray.6'>Price: <NumberFormatter prefix={`${val.currency.toUpperCase()} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={val.price} suffix={` / ${val.quantity_unit}`} /></Text>
          </Box>
        </Table.Td>
        <Table.Td>
          {val.products.length > 0 ? <Group align='center' gap={4}>{remapDataProducts(val.products)}</Group> : <Text fz={13} c='gray.6'>No Recommendation</Text>}
        </Table.Td>
        <Table.Td>
          {val.quote_id.length > 0 ? <Group align='center' gap={4}>{remapDataQuote(val.quote_id)}</Group> : <Text fz={13} c='gray.6'>No Product Quotes</Text>} 
        </Table.Td>
        <Table.Td>
          <Box>
            <Anchor fz={13} underline="hover" c={val.user !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.user)}>{val.user !== null ? val.user.name : 'No User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td>
          <Box>
            <Anchor fz={13} underline="hover" c={val.agent !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.agent)}>{val.agent !== null ? val.agent.name : 'No User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td>
          <Box>
            <Anchor fz={13} underline="hover" c={val.product_seeker !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.product_seeker)}>{val.product_seeker !== null ? val.product_seeker.name : 'No Product Seeker'}</Anchor>
          </Box>
        </Table.Td>
        <Table.Td>
          <Box>
            <Anchor fz={13} underline="hover" c={val.creator !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.creator)}>{val.creator !== null ? val.creator.name : 'No User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td>
          <Box>
            <Anchor fz={13} underline="hover" c={val.updater !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.updater)}>{val.updater !== null ? val.updater.name : 'No User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.updated_at).format('DD/MMMM/YYYY')} - { dayjs(val.updated_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td><Badge variant="light" color="black" tt='capitalize' fz={12} fw='500'>{val.status.length > 0 ? val.status[0].name : '-'}</Badge></Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} detail={val} /></Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Box>
      <Table.ScrollContainer minWidth={1366} type='native'>
        <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
          <Table.Thead style={{ backgroundColor: '#eeefef' }}>
            <Table.Tr>
              {mappingTableHead(label)}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody style={{ verticalAlign: 'top' }}>
            {mappingDataTable(data)}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
      <Modal opened={openModalImage} onClose={onCloseModalImage} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Preview Image</Text>} scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <Flex justify='center'>
          <Paper shadow="sm" withBorder>
            <Image w='auto' h={350} fit='contain' radius='md' src={previewImage !== null ? previewImage : NoImage} />
          </Paper>
        </Flex>
        <Flex mt={30} justify='flex-end'>
          <Button size='xs' variant="outline" onClick={onCloseModalImage}>Close</Button>
        </Flex>
      </Modal>
    </Box>
  )
}

export default TableProductRequest